var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"sidebar__icon"},[_c('inline-svg',{attrs:{"src":require(`@/assets/img/${this.path}.svg`)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }